import styled from 'styled-components';
import { Image as ImageBase } from '@hamrolt/components';
import { useDocument } from '../hooks/useDocument';
import { FileData, fileDefaultData } from '../hooks/useFile';
import { DocumentReference } from '../firebase';

type Order = string[];

interface CommonData {
	order: Order;
	image: FileData;
}

interface LocalizedData {
	heading: string;
	bodyHTML: string;
}

const defaultLocalizedData: LocalizedData = {
	heading: '',
	bodyHTML: ''
};

interface Props {
	res: {
		base: DocumentReference;
		localized: DocumentReference;
	};
	className?: string;
}

const Title = styled.h2`
	${({ theme }) => theme.typography.heading4};
	margin: 0 0 48px;
	color: ${({ theme }) => theme.palette.primary.main};
	text-transform: uppercase;
	text-align: center;
`;

const Container = styled.section`
	justify-self: end;
	width: 360px;
	min-height: 360px;
	padding: 24px;
	box-shadow: 0 0 80px rgba(0, 0, 0, .08);
`;

const Body = styled.div`
	${({ theme }) => theme.typography.richtext};
`;

const Image = styled(ImageBase)`
	display: block;
	width: 100%;
	margin: 0 0 48px;
`;

const defaultCommonData: CommonData = {
	order: [],
	image: fileDefaultData
};

export const About = ({ res, className }: Props) => {
	const { data: common } = useDocument<CommonData>(res.base, defaultCommonData);
	const { data: localized } = useDocument<LocalizedData>(res.localized, defaultLocalizedData);

	return <Container id="o-mnie" className={className} data-testid="about">
		<Title>{localized.heading}</Title>
		<Image src={common.image.url} />
		<Body dangerouslySetInnerHTML={{ __html: localized.bodyHTML }} />
	</Container>
}